import {Domain} from '@twpub/core/models/domain';
import {DisplayDomain, DomainPath} from '@twpub/core/models/display-entry';

export class DomainTree {
  id?: number;
  topLevelDomains: Domain[] = [];

  private sortByName = (a: Domain, b: Domain) => a.name.localeCompare(b.name, 'en', {sensitivity: 'base'});

  constructor(data: Partial<DomainTree> = {}) {
    this.id = data.id;
    this.topLevelDomains = data.topLevelDomains?.map(d => this.transformDomain(d)).sort(this.sortByName) || [];
  }

  private transformDomain(data: any): Domain {
    return {
      ...data,
      children: data.children.map((child: any) => this.transformDomain(child)).sort(this.sortByName)
    };
  }

  getParentDomain(id?: number): Domain | undefined {
    const domain = this.findDomainByIdRecursively(this.topLevelDomains, id);
    return domain ? this.findDomainByIdRecursively(this.topLevelDomains, domain.parentId) : undefined;
  }

  getPath(id?: number): DomainPath {
    const domain = this.findDomainById(id);
    if (!domain) {
      return {path: []};
    }

    const domains: DisplayDomain[] = [{name: domain.name, id: domain.id}];
    let parent = this.getParentDomain(domain.id);
    while (parent) {
      domains.unshift(parent);
      parent = this.getParentDomain(parent.id);
    }
    return {path: domains};
  }

  findDomainById(id?: number): Domain | undefined {
    return this.findDomainByIdRecursively(this.topLevelDomains, id);
  }

  private findDomainByIdRecursively(domains: Domain[], id?: number): Domain | undefined {
    for (const domain of domains) {
      if (domain.id === id) {
        return domain;
      }
      const found = this.findDomainByIdRecursively(domain.children, id);
      if (found) {
        return found;
      }
    }
    return undefined;
  }
}
